import Svasti1 from '../../../Media/BSD/Tanakayu/Tanakayu Svasti.webp'
import Svasti2 from '../../../Media/BSD/Tanakayu/Tanakayu Svasti.webp'





const Svastiimages =[
Svasti1,Svasti2
]

export default Svastiimages;